import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Injectable({
  providedIn: 'root',
})
export class PolicyDataService {
  private policyDetails: any = null;
  public details = new BehaviorSubject<any>(this.policyDetails);
  $policyDetails = this.details.asObservable();
  private rawPolicies = new BehaviorSubject<any[]>(null);
  $rawPolicies = this.rawPolicies.asObservable();
  public policyNumber: string;
  public policyList: any;

  private removePaperless: any = {};
  public removePaperlessStatus = new BehaviorSubject<any>(this.removePaperless);
  $removePaperless = this.removePaperlessStatus.asObservable();

  private renewalPolicy: any[] = [];
  public renewalPolicyList = new BehaviorSubject<any>(this.renewalPolicy);
  $renewalPolicy = this.renewalPolicyList.asObservable();

  private expiringLivoPolicies: any[] = [];
  public expiringLivoPolicyList = new BehaviorSubject<any>(
    this.expiringLivoPolicies
  );
  $expiringLivoPolicies = this.expiringLivoPolicyList.asObservable();

  private expiringPoliciesFor5Month: any = [];
  public activePoliciesListForMorethan5Months = new BehaviorSubject<any>(
    this.expiringPoliciesFor5Month
  );
  $activePoliciesForMorethan5Months =
    this.activePoliciesListForMorethan5Months.asObservable();
  zipCode: string;
  isAcmic: boolean;

  constructor(private acmicService: AcmicService) {
    this.isAcmic = this.acmicService.isACMIC();
  }

  updatePolicyDetails(policyDetails: any) {
    this.addDisplayPolicyTypeAndIcon(policyDetails);
    this.details.next(policyDetails);
  }

  updateRenewalPolicy(policy: any) {
    this.renewalPolicyList.next(policy);
  }

  clearRenewalPolicy() {
    this.renewalPolicyList.next('');
  }

  updateExpiringLivoPolicies(policies: any) {
    this.expiringLivoPolicyList.next(policies);
  }
  updateActivePoliciesListForMorethan5Months(policies: any) {
    this.activePoliciesListForMorethan5Months.next(policies);
  }

  clearExpiringLivoPolicies() {
    this.expiringLivoPolicyList.next('');
  }
  clearactivePoliciesListForMorethan5Months() {
    this.activePoliciesListForMorethan5Months.next('');
  }

  updateStatus(status: any) {
    this.removePaperlessStatus.next(status);
  }

  clear() {
    this.details.next('');
  }

  getPolicyNumber() {
    return this.policyNumber;
  }

  setPolicyNumber(policyNumber: string) {
    this.policyNumber = policyNumber;
  }

  getPolicyList() {
    return this.policyList;
  }

  setPolicyList(policyList: any) {
    this.policyList = policyList;
    this.rawPolicies.next(policyList);
  }

  getZipCode() {
    return this.zipCode;
  }
  setZipCode(zipCode) {
    this.zipCode = zipCode;
  }
  clearZipcode() {
    this.zipCode = '';
  }
  getActiveAutoPolicies(policyResponse) {
    return policyResponse.filter(policy => policy.policyStatus === 'ACTIVE' && policy.policyType === 'AUTO');
  }

  private addDisplayPolicyTypeAndIcon(policyDetails: any[]) {
    if (!Array.isArray(policyDetails)) {
      return;
    }
    policyDetails.forEach(policy => {
      const policyNum = policy?.policynumber?.policyNumber ?? '';
      if (!policy.displayType) {
        const normalizedPolicyType = (policy?.policyType || '').toUpperCase();
        policy.displayType = {
          label: normalizedPolicyType.includes('HOME') && policyNum.length !== 6
            ? "Personal property"
            : normalizedPolicyType.includes('AUTO') && policyNum.length !== 6
              ? 'Personal auto'
              : (policy?.policyType?.charAt(0).toUpperCase() + policy?.policyType?.slice(1)?.toLowerCase()).replace('_', ' '),
          icon: this.getPolicyTypeIcon(policy)
        }
      }
    }
    );
  }

  private getPolicyTypeIcon(policy): string {
    if (this.isAcmic) {
      return (policy?.policyType?.includes('UMBRELLA'))
        ? "./assets/img/images/icon-newumbrella-acmic.svg"
        : (policy?.policyType.includes('HOME'))
          ? "./assets/img/images/icon-newhome-acmic.svg"
          : "./assets/img/images/icon-newcar-acmic.svg"
    }
    return (policy?.policyType === 'AUTO') ? "./assets/img/images/icon-car.svg"
      : (policy?.policyType?.includes('HOME')) ? "./assets/img/images/icon-home.svg"
        : (policy?.policyType?.includes('UMBRELLA')) ? "./assets/img/images/icon-umbrella.svg"
          : (policy?.policyType?.toLowerCase() === 'commercial_auto')
            ? "/assets/img/images/icon-freight-transport.svg"
            : (policy?.policyType?.toLowerCase() === 'commercial_fire')
              ? "/assets/img/images/icon-car-fire.svg"
              : (policy?.policyType?.toLowerCase() === 'garage_keeper')
                ? "/assets/img/images/icon-car-home.svg"
                : (policy?.policyType?.toLowerCase() === 'special_multi_peril')
                  ? "/assets/img/images/icon-multiple-circle.svg"
                  : (policy?.policyType?.toLowerCase() === 'scheduled_property')
                    ? "/assets/img/images/icon-tool-wrench.svg"
                    : "/assets/img/images/icon-personal-lawyer.svg"
  }
}
